module.exports = __webpack_public_path__ + "static/media/plus.ca4824ee.png";